export default "__VITE_ASSET__618432f0__"